import React from 'react';
import RootLayout from "@/app/layout";
import { AgbSection } from '@/app/components/sections/AgbSection';
import data from '../../data/AGB.json';
import Head from 'next/head';

export const metadata = {
    title: 'GesundheitGanzheitlich - AGB',
    description: 'Lesen Sie unsere Allgemeinen Geschäftsbedingungen (AGB), um mehr über die Regeln und Bedingungen unserer Dienstleistungen zu erfahren.',
    canonicalUrl: 'https://gesundheitganzheitlich.ch/agb',
    keywords: 'AGB, Allgemeine Geschäftsbedingungen, Gesundheit, Ganzheitlich, Graubünden, Igis, Schweiz, Dienstleistungen'
  }
  
  
  
  

export async function getStaticProps() {
    return { props: { data } }
}

export default function Agb({ data }) {
    return (
        <RootLayout>
            <Head>
                <title>{metadata.title}</title>
                <meta name="description" content={metadata.description} />
                <meta name="keywords" content={metadata.keywords} />
                <link rel="canonical" href={metadata.canonicalUrl} />
            </Head>
            <AgbSection data={data} />
        </RootLayout>
    );
}
